import React from 'react';
import get from 'lodash/get';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { StandaloneCheckbox } from 'web-ui-components/lib/data/capture';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isChecked } from '../../../utils/validation';

const SwitchDateTermsAgree = ({ values }) => (
  <Content>
    {({ switchDateTerms2Label = '', switchDateTerms2ValidationMessage = '' }) => (
      <Field
        name="switchDateAgree"
        subscription={{ touched: true, error: true }}
        validate={isChecked}
      >
        {({ meta: { touched, error }, input }) => (
          <GenericFieldWrapper
            inputId="switchDateAgree"
            validationMessage={touched && !!error ? switchDateTerms2ValidationMessage : ''}
          >
            <StandaloneCheckbox
              isChecked={get(values, 'switchDateAgree.isChecked', false)}
              id="switchDateAgree"
              labelText={switchDateTerms2Label}
              onChange={({ isChecked }) => {
                input.onChange(isChecked);
              }}
              {...input}
            />
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);
export default SwitchDateTermsAgree;
